// Reseñas en el JSON-LD: solo las verificadas de Ágora, igual que la vidriera de agora.red
// (nightwing `app/utils/reviewSchema.ts`). El puntaje de Google no entra al marcado: la guía de
// datos estructurados de Google pide no juntar reseñas de otros sitios. La ficha se vincula con
// `sameAs` (link de Maps) para que Google sepa que es el mismo negocio.

// Mismo umbral que la píldora de la vidriera: con una o dos reseñas el promedio no dice nada.
const SCHEMA_MIN_REVIEWS = 3;
const SCHEMA_MAX_REVIEWS = 5;

/** `{ rating, review_count }` de `GET /vendors/:u/reviews` (vacía si el negocio no las muestra). */
export function buildAggregateRating(stats) {
  const rating = Number(stats?.rating);
  const count = Number(stats?.review_count) || 0;
  if (count < SCHEMA_MIN_REVIEWS || !Number.isFinite(rating) || rating < 1 || rating > 5) return null;
  return {
    '@type': 'AggregateRating',
    ratingValue: rating.toFixed(1),
    reviewCount: String(count),
    bestRating: '5',
    worstRating: '1'
  };
}

/** Las más recientes con comentario, sin filtrar por puntaje: elegir solo las buenas sería maquillar. */
export function buildSchemaReviews(reviews) {
  return (reviews || [])
    .filter((r) => r?.comment?.trim() && r.rating >= 1 && r.rating <= 5)
    .slice(0, SCHEMA_MAX_REVIEWS)
    .map((r) => ({
      '@type': 'Review',
      reviewRating: { '@type': 'Rating', ratingValue: String(r.rating), bestRating: '5', worstRating: '1' },
      author: { '@type': 'Person', name: r.customer_first_name?.trim() || 'Cliente verificado' },
      ...(r.created_at && { datePublished: String(r.created_at).slice(0, 10) }),
      reviewBody: r.comment.trim()
    }));
}

/** Link estable a la ficha de Maps: sin los parámetros de sesión (`g_mp`) que agrega Places. */
export function googleMapsSameAs(place) {
  if (!place || place.is_hidden || !place.maps_url) return null;
  try {
    const url = new URL(place.maps_url);
    const cid = url.searchParams.get('cid');
    if (cid && /^\d+$/.test(cid)) return `https://maps.google.com/?cid=${cid}`;
    return url.protocol === 'https:' ? url.toString() : null;
  } catch {
    return null;
  }
}

/** Ficha del directorio: el `place_id` de Google identifica el negocio sin copiar su puntaje. */
export function googlePlaceSameAs(placeId) {
  return placeId && /^[\w-]+$/.test(placeId)
    ? `https://www.google.com/maps/place/?q=place_id:${placeId}`
    : null;
}
